export const LOCATION_KEY = '@location';
export const CACHE_LOCATION_FROM_URL = '@location/update';
